import { render, staticRenderFns } from "./SectionWelcome.vue?vue&type=template&id=01ed7f75&scoped=true&"
import script from "./SectionWelcome.vue?vue&type=script&lang=ts&"
export * from "./SectionWelcome.vue?vue&type=script&lang=ts&"
import style0 from "./SectionWelcome.vue?vue&type=style&index=0&id=01ed7f75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ed7f75",
  null
  
)

export default component.exports